import { memo } from 'react'
import type { TextareaHTMLAttributes } from 'react'

interface TextAreaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string
  showCount?: boolean
}

const DEFAULT_MAX_LENGTH = 500

export const TextArea = memo(function TextArea({ label, className = '', showCount = false, maxLength = DEFAULT_MAX_LENGTH, ...props }: TextAreaProps) {
  const currentLength = typeof props.value === 'string' ? props.value.length : 0
  const isNearLimit = currentLength > maxLength * 0.9

  return (
    <div className="w-full">
      {label && (
        <label className="block text-sm text-white/70 font-medium mb-2">{label}</label>
      )}
      <textarea
        maxLength={maxLength}
        className={`w-full px-5 py-4 bg-white/10 border-2 border-transparent rounded-2xl text-white text-base font-medium placeholder:text-white/40 focus:outline-none focus:border-pink focus:bg-white/15 transition-all resize-none ${className}`}
        {...props}
      />
      {showCount && (
        <p className={`text-xs mt-1 text-right ${isNearLimit ? 'text-yellow' : 'text-white/40'}`}>
          {currentLength}/{maxLength}
        </p>
      )}
    </div>
  )
})
